import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/authStore';

export function usePermissions() {
  const authStore = useAuthStore();
  const { permissions } = storeToRefs(authStore);

  const can = (permission) => authStore.hasPermission(permission);
  const canAny = (...required) => authStore.hasAnyPermission(required);
  const canAll = (...required) => authStore.hasAllPermissions(required);

  return {
    permissions,
    can,
    canAny,
    canAll
  };
}